module.exports = __webpack_public_path__ + "static/media/Team 21 - Health Guardians.61e95f6f.png";